export const en = {
  buttons: {
    login: "Login",
    logout: "Logout",
    back: "Back",
    cancel: "Cancel",
    close: "Close",
    create: "create",
    forgotPassword: "Forgot your password?",
    createTicket: "Create new ticket",
  },
  labels: {
    email: "E-mail",
    password: "Password",
    confirmPassword: "Confirm password",
    createPassword: "Create password",
    orders: "Orders",
    tickets: "Tickets",
    passwordLength: "The password must be at least 6 characters long.",
    title: "Title",
    orderNumber: "Order Number",
    ticketNumber: "Ärendenummer",
    phoneNumber: "Phone Number",
    category: "Category",
    categoryPlaceholder: "Select category",
    componentName: "Component Name",
    faultSymptom: "Fault Symptom",
    replacementMaterialWanted: "Replacement Material Wanted",
    replacementMaterialHint:
      "Observe that replacement material will be billed and credited if the case is deemed covered under warranty after analysis.",
    electronics: "Electronics",
    mechanics: "Mechanics",
    materialInDelivery: "Material in Delivery",
    image: "Image",
    yourName: "Your name",
    customer: "Customer",
    reportedBy: "Reported By",
    created: "Created",
    ticket: "Ticket",
    noTickets: "No tickets found for this customer.",
    yes: "Yes",
    no: "No",
    status: "Status",
    contact: "Contact",
    comment: "Status update",
    lastUpdated: "Last updated",
    ticketDetails: "Ticket Details",
  },
  loadingMore: "Loading more orders...",
  loadingMoreTickets: "Loading more tickets...",
  texts: {
    welcomeMessage: "Welcome to the customer portal,",
    welcomeMessageWithoutUserTitle: "Welcome to the customer portal!",
    customerPortalBurdy: "Customer portal - Burdy",
    customerPortalHisselektronik: "Customer portal - Hisselektronik",
  },
  success: {
    login: "Welcome",
    logout: "You are logged out!",
    downloaded: "The file was downloaded successfully!",
    ticketCreated: "Ticket {{number}} created!",
  },
  warning: {
    customerNotFound: "Ticket created but customer \"{{customer}}\" was not found in the system. The customer field is empty in SharePoint.",
  },
  error: {
    swr: "Something went wrong.",
    userFetch: "Failed to fetch user",
    orders: "Failed to fetch orders",
    tickets: "Failed to fetch tickets",
    zip: "Failed to download the folders content",
    passwordMatch: "The passwords do not match.",
    ticketCreate: "Failed to create ticket.",
  },
  info: {
    tokenExpired: "Your session has expired. Please log in again.",
    firstLogin: "Welcome! Please enter a new password to log in.",
  },
};
